import { MessageWrapper } from 'components/messageWrapper/messageWrapper.module';
import {
	ALLOWED_FILE_EXTENSIONS,
	ALLOWED_FILE_SIZE,
	ALLOWED_VIDEO_FILE_EXTENSIONS,
	ALLOWED_VIDEO_FILE_SIZE,
} from 'consts/consts';
import { BUTTON_SIZE, BUTTON_TYPE, MESSAGE_TYPE } from 'consts/enum';
import { LS } from 'consts/localStorage';
import {
	addClass,
	generate6DigitUUID,
	getExtension,
	getFileTypeImg,
	getFormatedFileSize,
	onEditResponse,
	removeClass,
	removeElement,
	setCustomTagHTML,
	storeSkipInLS,
	writeToLs,
} from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';
import { appendChatContent } from 'js/conversation';
import { Button } from 'ui/button/button.module';
import { uploadFile } from './fileUpload.api';
import { FileUploadTemplate } from './fileUpload.template';

export default class FileUpload {
	constructor(props) {
		this.initData(props);
		this.initWrapper();
		this.initComponents();
		this.initEventHandlers();
	}

	initData(propData = {}) {
		this.data = {};
		this.setter({
			...propData,
			uploadedFile: {},
			id: propData.message_id || generate6DigitUUID(),
			text: propData?.message?.text || '',
			description: propData?.message?.description || '',
		});
	}

	renderEditBtn() {
		const editBtn = this.html.querySelector(`#editBtn-${this.data.id}`);
		editBtn.style.display = 'block';
	}

	initWrapper() {
		const wrapper = document.createElement('div');
		wrapper.id = `engt-file-${this.data.id}`;
		wrapper.classList.add('engt-msg', 'engt-msg-bot', 'engt-msg-border-bot', 'engt-msg-file-upload');
		wrapper.innerHTML = FileUploadTemplate(this.data);

		this.html = wrapper;
	}

	initComponents() {
		const ref = this;
		const { message } = this.data;
		const isOldMsg = this.data.isOldMessage;
		const skip = message?.enable_skip && !isOldMsg;
		const skipPostBack = message?.skip_postback;

		this.html = new MessageWrapper({
			...this.data,
			message: this.data.text,
			innerHTML: this.html.outerHTML,
		});

		this.uploadBtn = !isOldMsg
			? new Button({
					type: BUTTON_TYPE.PRIMARY,
					size: BUTTON_SIZE.LARGE,
					label: ENGT_CHAT.get('GENERIC_STRINGS')?.['UPLOAD'] || 'Upload',
					style: 'margin-top: 24px;',
					radius: 18,
					id: 'fileUploadBtn',
					disabled: true,
					applyOnHover: true,
					tabIndex: 0,
					onClick() {
						this.disabled = true;
						addClass(ref.previewWrapper, 'engt-msg-file-upload-progress');
						ref.clearError();
						uploadFile.call(ref);
					},
			  }).render()
			: '';

		this.skipButton = skip
			? new Button({
					type: BUTTON_TYPE.MINI,
					size: BUTTON_SIZE.SMALL,
					label: ENGT_CHAT.get('GENERIC_STRINGS')?.['SKIP'] || 'Skip',
					style: 'margin-top: 12px;',
					applyOnHover: true,
					radius: 18,
					id: 'fileSkipBtn',
					tabIndex: 0,
					onClick() {
						ref.onSkip(skipPostBack);
						ref.reset();
						ref.destroyNode(ref.uploadBtn, ref.skipButton);
						writeToLs(
							LS().TAB_MESSAGES,
							JSON.stringify({
								action: 'update_file_msg',
								selectedValue: 'skip',
								id: ref.data.id,
								tabId: ENGT_CHAT.get('socketId'),
							})
						);
						ENGT_CHAT.get('enableAllInput')();
						storeSkipInLS();
					},
			  }).render()
			: '';

		setCustomTagHTML(this.html.querySelector('upload-btn'), this.uploadBtn);
		setCustomTagHTML(this.html.querySelector('skip-btn'), this.skipButton);

		if (ENGT_CHAT.get('config.edit_user_input') && !isOldMsg) {
			const editButton = new Button({
				type: BUTTON_TYPE.MINI,
				label: ENGT_CHAT.get('config.default_edit_response')
					? ENGT_CHAT.get('config.default_edit_response')
					: ENGT_CHAT.get('GENERIC_STRINGS')?.['EDIT'] || 'Edit',
				id: `editBtn-${this.data.id}`,
				style: 'display:none;',
				applyOnHover: true,
				onClick() {
					const flowKey = ref.data.flow_key;
					const nodeKey = ref.data.node_key;
					if (flowKey && nodeKey) {
						this.style.display = 'none';
						onEditResponse(flowKey, nodeKey);
						ENGT_CHAT.set('editFlowId', '');
					} else console.error('flow key and and node key are not set and hence not triggering edit flow');
				},
				radius: 18,
			}).render();

			setCustomTagHTML(this.html.querySelector('edit-btn'), editButton);
			ENGT_CHAT.set('editFlowId', `editBtn-${this.data.id}`);
		} else {
			setCustomTagHTML(this.html.querySelector('edit-btn'), '');
		}
	}

	initEventHandlers() {
		const ref = this;

		!this.data.isOldMessage &&
			this.html.querySelector('[data-id="inputTriggerBtn"]').addEventListener('click', () => {
				ref.html.querySelector('[data-id="inputField"]').click();
			});

		this.html
			.querySelector('[data-id="inputField"]')
			?.addEventListener?.('change', this.onFileSelection.bind(this));

		this.html.querySelector('[data-id="engtFileDropZone"]')?.addEventListener?.('drop', this.onFileDrop.bind(this));

		this.html.querySelector('[data-id="engtFileDropZone"]')?.addEventListener?.('dragover', (event) => {
			event.preventDefault();
		});

		this.html.querySelector('.preview-overlay')?.addEventListener?.('click', () => {
			ref.removeFile();
			ref.clearError();
		});

		this.html.querySelector('[data-id="engtRemoveUpload"]')?.addEventListener?.('click', () => {
			ref?.uploadRequest?.abort?.();
			ref.resetProgressBar();
		});

		ENGT_CHAT.set('showUploadedFile', this.showFile.bind(this));
	}

	onSkip(payload) {
		if (payload && (payload !== null || payload !== 'null')) {
			ENGT_CHAT.get('sendMessage')('skip', {
				message: {
					postback: payload,
					type: 'postback',
					text: 'skip',
				},
				skipAppendToDom: true,
			});
		}
	}

	showFile(file, syncing = false) {
		const [, fileType] = file?.type?.split?.('/');
		this.previewWrapper = this.html.querySelector('.engt-msg-file-upload-preview');
		this.previewImg = this.html.querySelector('.preview-image');
		this.previewFile = this.html.querySelector('.preview-file');
		this.previewSize = this.html.querySelector('.preview-size');

		if (file.type.indexOf('image') > -1) {
			addClass(this.previewWrapper, 'engt-msg-file-upload-img');
			removeClass(this.previewWrapper, 'engt-msg-file-upload-file');
			this.previewImg.src = syncing ? file.src : URL.createObjectURL(file);
			this.previewImg.style = '';
			this.previewFile.innerText = '';
			this.previewSize.innerText = '';
		} else {
			addClass(this.previewWrapper, 'engt-msg-file-upload-file');
			removeClass(this.previewWrapper, 'engt-msg-file-upload-img');
			this.previewImg.src = getFileTypeImg(fileType);
			this.previewFile.innerText = file.name;
			this.previewSize.innerText = getFormatedFileSize(file.size);
		}

		this.html.querySelector('.engt-msg-file-upload-preview').style.display = 'flex';
		this.html.querySelector('[data-id="engtFileDropZone"]').style.display = 'none';
		this.html.querySelector('#fileUploadBtn').disabled = false;
		this.clearError();
	}

	removeFile() {
		this.html.querySelector('.engt-msg-file-upload-preview').style.display = 'none';
		this.html.querySelector('[data-id="engtFileDropZone"]').style.display = 'flex';
		this.html.querySelector('#fileUploadBtn').disabled = true;
		this.setter({
			uploadedFile: {},
		});
	}

	checkErrorAndShowFile(file) {
		const extension = getExtension(file?.name || '').toLowerCase();
		const isVideoFile = ALLOWED_VIDEO_FILE_EXTENSIONS.includes(extension) || file?.type?.indexOf('video') > -1;
		const allowedFileSize = isVideoFile ? ALLOWED_VIDEO_FILE_SIZE : ALLOWED_FILE_SIZE;
		const genericStrings = ENGT_CHAT.get('GENERIC_STRINGS');
		const fileSizeError = isVideoFile
			? genericStrings?.FILE_UPLOAD_VIDEO_SIZE_ERROR || 'Maximum allowed video file size - 25mb'
			: genericStrings?.FILE_UPLOAD_FILE_SIZE_ERROR || 'Maximum allowed file size - 5mb';

		if (!file) {
			this.setError('File not supported !');
		} else if (!ALLOWED_FILE_EXTENSIONS.includes(extension)) {
			this.setError('File not supported !');
		} else if (file.size > allowedFileSize) {
			this.setError(fileSizeError);
		} else {
			this.setter({
				uploadedFile: file,
			});
			this.showFile(file);
		}
	}

	onFileSelection(e) {
		const [file] = e.target.files;
		this.checkErrorAndShowFile(file);
	}

	onFileDrop(ev) {
		ev.preventDefault();
		if (ENGT_CHAT.get('startConvoAdded') || this.data.isOldMessage) {
		} else if (ev.dataTransfer.items) {
			const files = ev.dataTransfer.items;
			[...files].forEach((item, i) => {
				if (item.kind === 'file' && files.length - 1 === i) {
					const file = item.getAsFile();
					this.checkErrorAndShowFile(file);
				}
			});
		} else {
			const { files } = ev.dataTransfer;
			[...files].forEach((file, i) => {
				if (files.length - 1 === i) {
					this.checkErrorAndShowFile(file);
				}
			});
		}
	}

	showProgressBar(size) {
		if (size) {
			this.html.querySelector(
				'.engt-status-indicator-div'
			).style.background = `linear-gradient(90deg, var(--engt-theme-color) ${size}%, #fff 0)`;
		}
	}

	resetProgressBar() {
		this.uploadBtn.disabled = false;
		this.html.querySelector('.engt-status-indicator-div').style.background = 'white';
		removeClass(this.previewWrapper, 'engt-msg-file-upload-progress');
	}

	setError(message) {
		const errorDiv = this.html.querySelector('.engt-msg-file-upload-error');
		if (message) {
			errorDiv.innerHTML = message;
			errorDiv.style.display = 'block';
		}
	}

	clearError() {
		const errorDiv = this.html.querySelector('.engt-msg-file-upload-error');
		errorDiv.innerHTML = '';
		errorDiv.style.display = 'none';
	}

	reset() {
		this.clearError();
		this.removeFile();
	}

	destroyNode(uploadBtn, skipBtn) {
		const overlay = this.html.querySelector('.preview-overlay');
		this.html.querySelector('.engt-msg-file-upload-preview').classList.add('engt-msg-file-upload-complete');
		this.html.querySelector('[data-id="inputField"]').disabled = true;
		this.html.querySelector('[data-id="engtFileDropZone"]').removeEventListener('drop', this.onFileDrop);
		skipBtn && removeElement(skipBtn);
		removeElement(uploadBtn);
		removeElement(overlay);
	}

	// storing uploaded file in ls for chat history
	updateLSForFile(fileData = {}) {
		const messageData = {
			...fileData,
			mimeType: fileData.mime_type,
			type: '',
		};
		const msgData = {
			agent_avatar: undefined,
			agent_name: undefined,
			message: JSON.stringify(messageData),
			message_id: null,
			messagetype: MESSAGE_TYPE.FILE_RECEIVED,
			sender: 'user',
			timestamp: new Date().getTime(),
			user_id: ENGT_CHAT.get('status.sessionKey'),
			bot_ref: ENGT_CHAT.get('config.botRef'),
			bot_key: ENGT_CHAT.get('config.bot_key'),
		};
		appendChatContent(msgData);
	}

	sendFileViaSocket(resp, isPublicUpload = false) {
		const { url, name, mimeType, token } = resp?.responseObject || {};
		const dataPacket = {
			type: 'file',
			url: isPublicUpload ? url : token,
			name,
			transaction_id: null,
			mime_type: mimeType,
			token,
		};
		if (isPublicUpload) {
			delete dataPacket.token;
		}

		ENGT_CHAT.get('sendMessage')(name, { message: dataPacket, skipAppendToDom: true });

		this.updateLSForFile(dataPacket);

		if (ENGT_CHAT.get('config.edit_user_input')) {
			this.renderEditBtn();
		}
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
